/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ISourceEntityHandler } from '@principle-theorem/practice-migrations/interfaces';
import { isArray, uniq } from 'lodash';

export function getRequiredTableNames(
  entityHandlers: ISourceEntityHandler<any>[],
  implicitTables: string[] = []
): string[] {
  const tableNames = entityHandlers
    .flatMap((handler) => {
      const queries = isArray(handler.sourceQuery)
        ? handler.sourceQuery
        : [handler.sourceQuery];
      return queries.filter((query) => !!query);
    })
    .flatMap((query) => extractTableNamesFromQuery(query));

  return uniq([...tableNames, ...implicitTables]);
}

export function getRequiredCsvFilenames(
  entityHandlers: ISourceEntityHandler<any>[],
  implicitFiles: string[] = []
): string[] {
  const implicitTables = implicitFiles.map((file) =>
    file.replace(/\.csv$/i, '')
  );
  const tableNames = getRequiredTableNames(entityHandlers, implicitTables);
  return tableNames.map((table) => `${table}.csv`);
}

function extractTableNamesFromQuery(sql: string): string[] {
  const tables: string[] = [];

  // Match FROM clauses — handles comma-separated table lists
  // e.g. "FROM table1, table2, table3" captures "table1, table2, table3"
  // Negative lookahead (?!\() skips subqueries like "FROM (SELECT ...)"
  const fromRegex = /\bFROM\s+(?!\()((?:[a-zA-Z0-9_]+\s*,\s*)*[a-zA-Z0-9_]+)/gi;

  for (const match of sql.matchAll(fromRegex)) {
    for (const table of match[1].split(',')) {
      const trimmed = table.trim();
      if (trimmed) {
        tables.push(trimmed);
      }
    }
  }

  // Match JOIN clauses — skip subquery JOINs
  const joinRegex = /\bJOIN\s+(?!\()([a-zA-Z0-9_]+)/gi;

  for (const match of sql.matchAll(joinRegex)) {
    tables.push(match[1]);
  }

  return tables;
}
